import { Injectable } from '@angular/core';
import { InfoPagina } from '../interfaces/infopagina.interface';
import {
  FiltroRisorse,
  filtroRisorseRplVuoto,
  filtroRisorseVuoto,
} from '../interfaces/filtro-risorse.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  FiltroCommesse,
  filtroCommesseVuoto,
} from '../interfaces/filtro-commesse.interface';
import {
  filtroRettificheVuoto,
  FiltroRettifiche,
  FiltroRettificheCC,
  filtroRettificheCCVuoto,
  FiltroRettifichePC,
  filtroRettifichePCVuoto,
  FiltroRettificheRCD,
  FiltroRettificheRcdRpl,
  filtroRettificheRcdRplVuoto,
  filtroRettificheRCDVuoto,
  FiltroRettificheRgRpl,
  filtroRettificheRgRplVuoto,
  FiltroRettificheRisorsaRcd,
  FiltroRettificheRisorsaRcdVuoto,
  filtroRettificheRcdCooCfoVuoto,
  filtroRettificheRgCooCfoVuoto,
} from '../interfaces/filtro-rettifiche.interface';
import { Attori } from '../shared/enum/attori.enum';
import { FiltroElencoRisorse, filtroElencoRisorseVuoto } from '../interfaces/filtro-elenco-risorse.interface';
import { FiltroRiepilogoModifiche, filtroRiepilogoModificheVuoto } from '../interfaces/filtro-riepilogo-modifiche.interface';
import { FiltroDeleghe, filtroDelegheVuoto } from '../interfaces/filtro-deleghe.interface';

@Injectable({ providedIn: 'root' })
export class FiltroService {
  constructor() {}

  private _ultimoFiltroElencoRisorse = new BehaviorSubject<FiltroElencoRisorse>(
    filtroElencoRisorseVuoto
  );

  private _ultimoFiltroElencoRisorseNo1L = new BehaviorSubject<FiltroElencoRisorse>(
    filtroElencoRisorseVuoto
  );

  private _ultimoFiltroRiepilogoModifiche = new BehaviorSubject<FiltroRiepilogoModifiche>(
    filtroRiepilogoModificheVuoto
  );

  private _ultimoFiltroRiepilogoModificheNo1L = new BehaviorSubject<FiltroRiepilogoModifiche>(
    filtroRiepilogoModificheVuoto
  );

  private _ultimoFiltroRisorse = new BehaviorSubject<FiltroRisorse>(
    filtroRisorseVuoto
  );

  private _ultimoFiltroRisorseRg = new BehaviorSubject<FiltroRisorse>(
    filtroRisorseVuoto
  );

  private _ultimoFiltroRisorseRpl = new BehaviorSubject<FiltroRisorse>(
    filtroRisorseRplVuoto
  );

  private _ultimoFiltroCommesse = new BehaviorSubject<FiltroCommesse>(
    filtroCommesseVuoto
  );
  private _ultimoFiltroRettifiche = new BehaviorSubject<FiltroRettifiche>(
    filtroRettificheVuoto
  );
  private _ultimoFiltroRettificheRcd = new BehaviorSubject<FiltroRettificheRCD>(
    filtroRettificheRCDVuoto
  );
  private _ultimoFiltroRettificheRisorsaRcd =
    new BehaviorSubject<FiltroRettificheRisorsaRcd>(
      FiltroRettificheRisorsaRcdVuoto
    );

  private _ultimoFiltroRettificheRgRpl =
    new BehaviorSubject<FiltroRettificheRgRpl>(filtroRettificheRgRplVuoto);

  private _ultimoFiltroRettificheRcdRpl =
    new BehaviorSubject<FiltroRettificheRcdRpl>(filtroRettificheRcdRplVuoto);

  private _ultimoFiltroRettificheRcdCooCfo =
    new BehaviorSubject<FiltroRettificheRcdRpl>(filtroRettificheRcdCooCfoVuoto);

  private _ultimoFiltroRettificheRgCooCfo =
    new BehaviorSubject<FiltroRettificheRgRpl>(filtroRettificheRgCooCfoVuoto);

  private _ultimoFiltroRettifichePC = new BehaviorSubject<FiltroRettifichePC>(
    filtroRettifichePCVuoto
  );

  private _ultimoFiltroRettificheCC = new BehaviorSubject<FiltroRettificheCC>(
    filtroRettificheCCVuoto
  );

  private _ultimoFiltroDeleghe = new BehaviorSubject<FiltroDeleghe>(
    filtroDelegheVuoto
  );

  private _ultimaPaginaDeleghe: InfoPagina = {
    pageOffset: null,
    currentPage: null,
  };

  private _ultimaPagina: InfoPagina = {
    pageOffset: null,
    currentPage: null,
  };
  private _ultimaPaginaCommesse: InfoPagina = {
    pageOffset: null,
    currentPage: null,
  };

  private _ultimaPaginaRiepilogoModifiche: InfoPagina = {
    pageOffset: null,
    currentPage: null,
  };

  ultimoFiltroElencoRisorse(attore: Attori): Observable<FiltroElencoRisorse> {
    switch (attore) {
      case Attori.CFO:
      case Attori.DirettoreGenerale:
      case Attori.ControllerCentrale:
        return this._ultimoFiltroElencoRisorse.asObservable();
      case Attori.ControllerBU:
      case Attori.ResponsabilePrimoLivello:
        return this._ultimoFiltroElencoRisorseNo1L.asObservable();
      default:
        return this._ultimoFiltroElencoRisorse.asObservable();
    }
  }

  setUltimoFiltroElencoRisorse(filtro: FiltroElencoRisorse, attore: Attori) {
    filtro.pageNumber = this.ultimaPaginaInfo.currentPage
    ? this.ultimaPaginaInfo.currentPage + 1
    : 1;
    filtro.pageSize = this.ultimaPaginaInfo.pageOffset ?? 10;
    switch (attore) {
      case Attori.CFO:
      case Attori.DirettoreGenerale:
      case Attori.ControllerCentrale:
        this._ultimoFiltroElencoRisorse.next(filtro);
        break;
      case Attori.ControllerBU:
      case Attori.ResponsabilePrimoLivello:
        this._ultimoFiltroElencoRisorseNo1L.next(filtro);
        break;
      default:
        this._ultimoFiltroElencoRisorse.next(filtro);
        break;
    }
  }

  ultimoFiltroRiepilogoModifiche(attore: Attori): Observable<FiltroRiepilogoModifiche> {
    switch (attore) {
      case Attori.CFO:
      case Attori.DirettoreGenerale:
      case Attori.ControllerCentrale:
        return this._ultimoFiltroRiepilogoModifiche.asObservable();
      case Attori.ControllerBU:
      case Attori.ResponsabilePrimoLivello:
        return this._ultimoFiltroRiepilogoModificheNo1L.asObservable();
      default:
        return this._ultimoFiltroRiepilogoModifiche.asObservable();
    }
  }

  setUltimoFiltroRiepilogoModifiche(filtro: FiltroRiepilogoModifiche, attore: Attori) {
    filtro.pageNumber = this.ultimaPaginaRiepilogoModificheInfo.currentPage
      ? this.ultimaPaginaRiepilogoModificheInfo.currentPage + 1
      : 1;
    filtro.pageSize = this.ultimaPaginaRiepilogoModificheInfo.pageOffset ?? 10;
    switch (attore) {
      case Attori.CFO:
      case Attori.DirettoreGenerale:
      case Attori.ControllerCentrale:
        this._ultimoFiltroRiepilogoModifiche.next(filtro);
        break;
      case Attori.ControllerBU:
      case Attori.ResponsabilePrimoLivello:
        this._ultimoFiltroRiepilogoModificheNo1L.next(filtro);
        break;
      default:
        this._ultimoFiltroRiepilogoModifiche.next(filtro);
        break;
    }
  }

  ultimoFiltroRisorse(attore: Attori): Observable<FiltroRisorse> {
    switch (attore) {
      case Attori.ResponsabileGerarchico:
        return this._ultimoFiltroRisorseRg.asObservable();
      case Attori.ResponsabilePrimoLivello:
        return this._ultimoFiltroRisorseRpl.asObservable();
      default:
        return this._ultimoFiltroRisorse.asObservable();
    }
  }

  setUltimoFiltroRisorse(filtro: FiltroRisorse, attore: Attori) {
    switch (attore) {
      case Attori.ResponsabileGerarchico:
        this._ultimoFiltroRisorseRg.next(filtro);
        break;
      case Attori.ResponsabilePrimoLivello:
        this._ultimoFiltroRisorseRpl.next(filtro);
        break;
      default:
        this._ultimoFiltroRisorse.next(filtro);
        break;
    }
  }

  get ultimoFiltroRisorseRg() {
    return this._ultimoFiltroRisorseRg.asObservable();
  }

  get ultimoFiltroRisorseRgValue() {
    return this._ultimoFiltroRisorseRg.getValue();
  }

  setUltimoFiltroRisorseRg(filtro: FiltroRisorse) {
    this._ultimoFiltroRisorseRg.next(filtro);
  }

  get ultimoFiltroRisorseRpl() {
    return this._ultimoFiltroRisorseRpl.asObservable();
  }

  get ultimoFiltroRisorseRplValue() {
    return this._ultimoFiltroRisorseRpl.getValue();
  }

  setUltimoFiltroRisorseRpl(filtro: FiltroRisorse) {
    this._ultimoFiltroRisorseRpl.next(filtro);
  }

  get ultimoFiltroCommesse() {
    return this._ultimoFiltroCommesse.asObservable();
  }

  setUltimoFiltroCommesse(filtro: FiltroRisorse) {
    this._ultimoFiltroCommesse.next(filtro);
  }

  get ultimoFiltroRettifiche() {
    return this._ultimoFiltroRettifiche.asObservable();
  }

  setUltimoFiltroRettifiche(filtro: FiltroRettifiche, attore: Attori) {
    switch (attore) {
      case Attori.ResponsabilePrimoLivello:
        if (filtro.richiestaPerAttore == Attori.ResponsabileGerarchico) {
          this._ultimoFiltroRettificheRgRpl.next(filtro);
          break;
        } else {
          this._ultimoFiltroRettificheRcdRpl.next(filtro);
          break;
        }
      case Attori.PianificazioneControllo:
        this._ultimoFiltroRettifichePC.next(filtro);
        break;
      case Attori.ControllerCentrale:
      case Attori.ControllerBU:
        this._ultimoFiltroRettificheCC.next(filtro);
        break;
      case Attori.ResponsabileCommessaDestinazione:
        this._ultimoFiltroRettificheRcd.next(filtro);
        break;
      default:
        break;
    }
  }

  get ultimoFiltroRettificheRcd() {
    return this._ultimoFiltroRettificheRcd.asObservable();
  }

  get ultimoFiltroRettificheRcdValue(): FiltroRettificheRCD {
    return this._ultimoFiltroRettificheRcd.getValue();
  }

  setUltimoFiltroRettificheRcd(filtro: FiltroRettificheRCD) {
    this._ultimoFiltroRettificheRcd.next(filtro);
  }

  get ultimoFiltroRettificheRisorsaRcd() {
    return this._ultimoFiltroRettificheRisorsaRcd.asObservable();
  }

  get ultimoFiltroRettificheRisorsaRcdValue(): FiltroRettificheRisorsaRcd {
    return this._ultimoFiltroRettificheRisorsaRcd.getValue();
  }

  setUltimoFiltroRettificheRisorsaRcd(filtro: FiltroRettificheRisorsaRcd) {
    this._ultimoFiltroRettificheRisorsaRcd.next(filtro);
  }

  get ultimoFiltroRettificheRgRpl() {
    return this._ultimoFiltroRettificheRgRpl.asObservable();
  }

  get ultimoFiltroRettificheRgRplValue(): FiltroRettificheRgRpl {
    return this._ultimoFiltroRettificheRgRpl.getValue();
  }

  setUltimoFiltroRettificheRgRpl(filtro: FiltroRettificheRgRpl) {
    this._ultimoFiltroRettificheRgRpl.next(filtro);
  }

  get ultimoFiltroRettificheRcdRpl() {
    return this._ultimoFiltroRettificheRcdRpl.asObservable();
  }

  get ultimoFiltroRettificheRcdRplValue(): FiltroRettificheRcdRpl {
    return this._ultimoFiltroRettificheRcdRpl.getValue();
  }

  setUltimoFiltroRettificheRcdRpl(filtro: FiltroRettificheRcdRpl) {
    this._ultimoFiltroRettificheRcdRpl.next(filtro);
  }

  get ultimoFiltroRettificheRcdCooCfo() {
    return this._ultimoFiltroRettificheRcdCooCfo.asObservable();
  }

  get ultimoFiltroRettificheRcdCooCfoValue(): FiltroRettificheRcdRpl {
    return this._ultimoFiltroRettificheRcdCooCfo.getValue();
  }

  setUltimoFiltroRettificheRcdCooCfo(filtro: FiltroRettificheRcdRpl) {
    this._ultimoFiltroRettificheRcdCooCfo.next(filtro);
  }

  get ultimoFiltroRettificheRgCooCfo() {
    return this._ultimoFiltroRettificheRgCooCfo.asObservable();
  }

  get ultimoFiltroRettificheRgCooCfoValue(): FiltroRettificheRgRpl {
    return this._ultimoFiltroRettificheRgCooCfo.getValue();
  }

  setUltimoFiltroRettificheRgCooCfo(filtro: FiltroRettificheRgRpl) {
    this._ultimoFiltroRettificheRgCooCfo.next(filtro);
  }

  get ultimoFiltroRettifichePC() {
    return this._ultimoFiltroRettifichePC.asObservable();
  }

  get ultimoFiltroRettifichePCValue(): FiltroRettifichePC {
    return this._ultimoFiltroRettifichePC.getValue();
  }

  setUltimoFiltroRettifichePC(filtro: FiltroRettifichePC) {
    this._ultimoFiltroRettifichePC.next(filtro);
  }

  get ultimoFiltroRettificheCC() {
    return this._ultimoFiltroRettificheCC.asObservable();
  }

  get ultimoFiltroRettificheCCValue(): FiltroRettificheCC {
    return this._ultimoFiltroRettificheCC.getValue();
  }

  setUltimoFiltroRettificheCC(filtro: FiltroRettificheCC) {
    this._ultimoFiltroRettificheCC.next(filtro);
  }

  get ultimaPaginaInfo() {
    return this._ultimaPagina;
  }

  setUltimaPaginaInfo(ultimaPagina: InfoPagina) {
    this._ultimaPagina = ultimaPagina;
  }

  get ultimaPaginaCommesseInfo() {
    return this._ultimaPaginaCommesse;
  }

  setUltimaPaginaCommesseInfo(ultimaPagina: InfoPagina) {
    this._ultimaPaginaCommesse = ultimaPagina;
  }

  get ultimaPaginaRiepilogoModificheInfo() {
    return this._ultimaPaginaRiepilogoModifiche;
  }

  setUltimaPaginaRiepilogoModificheInfo(ultimaPagina: InfoPagina) {
    this._ultimaPaginaRiepilogoModifiche = ultimaPagina;
  }

  get ultimoFiltroDeleghe() {
    return this._ultimoFiltroDeleghe.asObservable();
  }

  get ultimoFiltroDelegheValue(): FiltroDeleghe {
    return this._ultimoFiltroDeleghe.getValue();
  }

  setUltimoFiltroDeleghe(filtro: FiltroDeleghe) {
    filtro.pageNumber = this.ultimaPaginaDelegheInfo.currentPage
      ? this.ultimaPaginaDelegheInfo.currentPage + 1
      : 1;
    filtro.pageSize = this.ultimaPaginaDelegheInfo.pageOffset ?? 10;
    this._ultimoFiltroDeleghe.next(filtro);
  }

  get ultimaPaginaDelegheInfo() {
    return this._ultimaPaginaDeleghe;
  }

  setUltimaPaginaDelegheInfo(ultimaPagina: InfoPagina) {
    this._ultimaPaginaDeleghe = ultimaPagina;
  }
}
